<template>
  <div>
    <b-modal ref="mdlConfirmar">
      <b-container>
        {{content}}
      </b-container>
      <div slot="modal-footer">
        <b-container>
          <b-row class="inline">
            <b-button ref="lnkNo" 
                      class="mr-1"
                      variant="secondary"
                      size="sm">{{$t('No')}}</b-button>
            <b-button ref="lnkYes"
                      class="mr-1"
                      variant="primary"
                      size="sm">{{$t('Yes')}}</b-button>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>
<script lang="js">
  export default {
    data() {
      return {
        value: {},
        content: '¿Desea borrar el item seleccionado?'
      };
    },
    methods: {
      ShowConfirmation(Content) {
        var self = this;
        this.content = Content || this.content;

        return new Promise(function (resolve, reject) {
          self.$refs.mdlConfirmar.show();

          self.$nextTick(() => {
            self.$refs.lnkYes.addEventListener('click', function () {
              resolve(true);
              self.$refs.mdlConfirmar.hide();
            });
            self.$refs.lnkNo.addEventListener('click', function () {
              resolve(false);
              self.$refs.mdlConfirmar.hide();
            });
          });
        });
      }
    }
  };
</script>
